import { apiClient, requiresAuth } from '../client';
import { Event } from '../../types';

export const eventsService = {
  getAllEvents: async () => {
    return requiresAuth(async () => {
      const response = await apiClient.get('/events');
      return response.data.events || response.data;
    });
  },

  getEventById: async (eventId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.get(`/events/${eventId}`);
      return response.data;
    });
  },

  createEvent: async (eventData: Partial<Event>) => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/events', eventData);
      return response.data;
    });
  },

  updateEvent: async (eventId: string, eventData: Partial<Event>) => {
    return requiresAuth(async () => {
      const response = await apiClient.put(`/events/${eventId}`, eventData);
      return response.data;
    });
  },

  /** Pin/unpin an event as featured. Pinning a recurring event pins its whole series. */
  setEventPinned: async (eventId: string, pinned: boolean) => {
    return requiresAuth(async () => {
      const response = await apiClient.patch(`/api/admin/events/${eventId}/pin`, { pinned });
      return response.data as { event: { _id: string; pinned: boolean } };
    });
  },

  deleteEvent: async (eventId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.delete(`/events/${eventId}`);
      return response.data;
    });
  },
};
